/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HealthCampRegistration from './health-camp-registration';
import HealthCampRegistrationDetail from './health-camp-registration-detail';
import HealthCampRegistrationUpdate from './health-camp-registration-update';
import HealthCampRegistrationDeleteDialog from './health-camp-registration-delete-dialog';

const HealthCampRegistrationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HealthCampRegistration />} />
    <Route path="new" element={<HealthCampRegistrationUpdate />} />
    <Route path=":id">
      <Route index element={<HealthCampRegistrationDetail />} />
      <Route path="edit" element={<HealthCampRegistrationUpdate />} />
      <Route path="delete" element={<HealthCampRegistrationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HealthCampRegistrationRoutes;
